import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export const sendOperatorFeedback = async ({ message, requestAccountDeletion = false }) => {
    const response = await apiFetch(`${API_BASE}/feedbacks/operator`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            message,
            request_account_deletion: requestAccountDeletion,
        }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data.detail || "Не вдалося відправити повідомлення");
    }

    return data;
};

// Отримати всі фідбеки (із токеном)
export const fetchFeedbacks = async () => {
    const response = await apiFetch(`${API_BASE}/feedbacks/operator`);

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.detail || "Помилка завантаження відгуків");
    }

    return data;
};

// Оновити фідбек (із токеном)
export const updateFeedback = async (id, data) => {
    const response = await apiFetch(`${API_BASE}/feedbacks/operator/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || "Помилка оновлення відгуку");
    }

    return await response.json();
};
